// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"82898dd33f80bf4b3831","418":"9f369b1064b48276432e","865":"82898dd33f80bf4b3831","4887":"82898dd33f80bf4b3831","7364":"82898dd33f80bf4b3831","8647":"82898dd33f80bf4b3831"}[chunkId] + ".chunk.css";
};